module.exports = __webpack_public_path__ + "img/location_pin.2e334fb6.png";